import SuspenseWrapper from '@src/components/suspenseWrapper';
import Loader from '@src/components/loader';
import lazyWithPreload from '@src/utils/lazyWithPreload';
import { RouteObject } from 'react-router-dom';
import { Path } from '../routes';
import Error from '@src/pages/error';
import Box from '@sendsprint/ui-react/dist/components/Box';

export const Dashboard = lazyWithPreload(() => import('@src/pages/receiver/dashboard'));
export const Transactions = lazyWithPreload(() => import('@src/pages/receiver/transactions'));
export const Settlements = lazyWithPreload(() => import('@src/pages/receiver/settlements'));
export const Customers = lazyWithPreload(() => import('@src/pages/receiver/customers'));
export const PaymentLinks = lazyWithPreload(() => import('@src/pages/receiver/paymentLinks'));
export const PaymentLinksDetails = lazyWithPreload(
  () => import('@src/pages/receiver/paymentLinkDetails')
);
export const Settings = lazyWithPreload(() => import('@src/pages/receiver/settings/settingsPage'));
export const Profile = lazyWithPreload(
  () => import('@src/pages/receiver/settings/settingsProfile')
);
export const BusinessPref = lazyWithPreload(
  () => import('@src/pages/receiver/settings/settingsBusinessRef')
);
export const SettlementAccounts = lazyWithPreload(
  () => import('@src/pages/receiver/settings/settlementAccounts')
);
export const SettlementAccountDetails = lazyWithPreload(
  () => import('@src/pages/receiver/settings/settlementAccountsDetails')
);

const routesData = [
  { path: Path.ReceiverDashboard, component: <Dashboard /> },
  { path: Path.ReceiverTransactions, component: <Transactions /> },
  { path: Path.ReceiverSettlements, component: <Settlements /> },
  { path: Path.ReceiverCustomers, component: <Customers /> },
  { path: Path.ReceiverPaymentLinks, component: <PaymentLinks /> },
  { path: `${Path.ReceiverPaymentLinks}/:reference`, component: <PaymentLinksDetails /> },
  { path: Path.ReceiverSettings, component: <Settings /> },
  { path: Path.ReceiverProfile, component: <Profile /> },
  { path: Path.ReceiverBusinessPref, component: <BusinessPref /> },
  { path: Path.ReceiverSettlementAccount, component: <SettlementAccounts /> },
  {
    path: `${Path.ReceiverSettlementAccount}/:accountNumber`,
    component: <SettlementAccountDetails />
  }
];

export const receiverRoutes: RouteObject[] = routesData.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));
